export const hideAllNavigationIcons = "HIDE_ALL_NAVIGATION_ICONS";
export const hideMenuAreaBar = "HIDE_MENU_AREA_BAR";
export const setMenuBarOrientation = "SET_MENU_BAR_ORIENTATION";
